export default {
  helloWorld: "Hello, World!",
  warning: "Warning",
  Close: "Close",
  NameSurname: "Name Surname",
  Dial: "Create Call",
  Default: "Default",
  Error: "Error",
  ErrorText: "An error occurred!",
  OK: "OK",

  DeviceSettings: "Device Settings",
  SelectMic: "Select Microphone Device",
  SelectCam: "Select Camera Device",
  Save: "Save",

  DemoInQueue: "You are in the queue. Please wait for an agent to connect.",
  DemoTitle: "Create a Demo Call",

  CheckingLicense: "Checking License..",

  AGENT_CHECK_FAIL: "Agent check failed!",
  AGENT_NOT_FOUND: "Agent not found!",
  UNKNOWN_LICENSE_TYPE: "Unknown license type!",

  ASSIGNED_LICENSE_CHECK_ERROR: "Assigned license check error!",
  ASSINGED_LICENSE_NOT_FOUND: "Assigned license not found!",
  ASSIGNED_LICENSE_CHECK_TOTAL_ERROR: "Assigned license checking total error!",
  LICENSE_COUNT_EXCEEDED: "License count exceeded!",
  ASSIGNED_LICENSE_INSERT_ERROR: "Assigned license insert error!",

  CONCURRENT_LICENSE_CANNOT_LOCK: "Concurrent license cannot lock!",
  CONCURRENT_LICENSE_FULL: "Concurrent license all slots are taken!",

  INFO: "Info",

  NoCameraPermission: "No camera permission!",
  NoMicrophonePermission: "No microphone permission!",

  MaxFileSizeExceeded: "File size cannot exceed {size} MB!",
  InvalidFileType: "Invalid file type! Accepted file types: {types}",
};
